import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Eres mamá primeriza', 'Te sientes perdida entre tanta info', 'Quieres alimentar mejor sin enloquecer'];
  const notForYou = ['No te interesa cocinar', 'Quieres recetas gourmet o complicadas', 'Buscas un manual técnico'];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-pink-light to-baby-blue-light" data-id="element-557">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-558">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-559">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-560">
            ¿Para Quién Es Este Ebook?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8" data-id="element-561">
          {/* For You */}
          <div className="bg-white/95 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg shadow-baby-glow border-2 border-baby-blue animate-fade-in-up" data-id="element-562">
            <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900 mb-6 text-center" data-id="element-563">
              ✓ Este ebook es para ti si:
            </h3>
            <div className="space-y-4 stagger-children" data-id="element-564">
              {forYou.map((item, index) => <div key={index} className="flex items-start gap-3 bg-baby-blue-light/50 p-4 rounded-baby" data-id="element-565">
                  <CheckCircleIcon className="w-6 h-6 text-baby-blue-dark flex-shrink-0 mt-0.5" data-id="element-566" />
                  <p className="text-sm sm:text-base text-gray-900 font-bold" data-id="element-567">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Not For You */}
          <div className="bg-white/95 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg shadow-baby-soft border-2 border-gray-300 animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-568">
            <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900 mb-6 text-center" data-id="element-569">
              ✗ No es para ti si:
            </h3>
            <div className="space-y-4 stagger-children" data-id="element-570">
              {notForYou.map((item, index) => <div key={index} className="flex items-start gap-3 bg-gray-100 p-4 rounded-baby" data-id="element-571">
                  <XCircleIcon className="w-6 h-6 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-572" />
                  <p className="text-sm sm:text-base text-gray-900 font-bold" data-id="element-573">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}